import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// ---------------------------------------------------------------------------
// Production console stripping
// ---------------------------------------------------------------------------
// In production builds we silence `log`, `info`, `debug`, and `warn` so the
// bundle does not leak diagnostic chatter into the user's DevTools or impact
// performance. `console.error` is intentionally preserved so genuine runtime
// crashes still surface for triage (e.g. via Sentry, browser inspector).
if (process.env.NODE_ENV === "production") {
  const noop = () => undefined;
  console.log = noop;
  console.info = noop;
  console.debug = noop;
  console.warn = noop;
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Register the Nia PWA service worker so the app can be installed and used
// offline. Skipped on `localhost` to avoid stale-cache pain during dev.
if ("serviceWorker" in navigator && typeof window !== "undefined") {
  const isLocalDev = window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1";
  if (!isLocalDev) {
    window.addEventListener("load", () => {
      navigator.serviceWorker
        .register("/service-worker.js", { scope: "/" })
        .catch(() => { /* SW registration is best-effort */ });
    });
  }
}
